var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isHotel
        ? _c("logo-with-image-editor", { attrs: { "is-admin": _vm.isAdmin } })
        : _c("logo-editor", { attrs: { "is-admin": _vm.isAdmin } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }